import React from "react";

import backup from "./screenshot.png";
import * as styles from "./styles.module.css";

export const NewsItemStatic = ({ story }) => {
  const descriptionNews = story.description;
  const titleNews = story.title;
  const linkNews = story.link;
  const imageNews = story.imageSource;
  const imageAltNews = story.imageAlt;

  return (
    <div className={styles.container}>
      <a href={linkNews} target="_blank" rel="noreferrer">
        <div className={styles.frame}>
          {imageNews ? (
            <img src={imageNews} alt={imageAltNews} />
          ) : (
            <img src={backup} alt="cwru logo" />
          )}
        </div>
        <h3>{titleNews}</h3>
        <p>{descriptionNews}</p>
      </a>
    </div>
  );
};

export default NewsItemStatic;
